/**
 * convert filter
 * used in angular to convert from one currency to another
 */
angular.module('bookingApp').filter('convert',['sessionFactory', function(sessionFactory){
    var convertFilter = function(input){
        if(typeof input !== 'undefined' && input !== null) {
            if(input.toString().indexOf('.')) {

                var convertedValue = fx(input).to(sessionFactory.selectedFilters.currency);

                return convertedValue;
            } else {
                return input;
            }
        } else {
            return 0.00;
        }
    };
    return convertFilter;
}]);